/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Unsavedchanges_Description1Inputs */

const en_common_unsavedchanges_description1 = /** @type {(inputs: Common_Unsavedchanges_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have unsaved changes. If you leave this page, your changes will be lost.`)
};

/**
* | output |
* | --- |
* | "You have unsaved changes. If you leave this page, your changes will be lost." |
*
* @param {Common_Unsavedchanges_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_unsavedchanges_description1 = /** @type {((inputs?: Common_Unsavedchanges_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Unsavedchanges_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_unsavedchanges_description1(inputs)
});
export { common_unsavedchanges_description1 as "common_unsavedChanges_description" }